import http from "../../http-common";

class DashboardService {
    getDashboardData(data) {
        return http.get("dashboard", { params: data });
    }
}

export default new DashboardService();